import { emailServices } from 'src/services/notification/email/email.service'

export const handleForwardEmail = async (
  record: any,
  cardId: string,
  setLoadingForwardEmailModal: React.Dispatch<React.SetStateAction<boolean>>,
  setOpenForwardEmailtModal: React.Dispatch<React.SetStateAction<boolean>>,
  notify: any,
  setCardLoading: any,
  getEmailHistory: any
) => {
  try {
    setLoadingForwardEmailModal(true)
    if (record) {
      const response = await emailServices.sendEmail(record)
      if (response === 200) {
        notify('ra.notification.forward_email_to_success', {
          type: 'success',
          messageArgs: { email_to: record?.email_to },
        })
        return
      }
    }
    notify('ra.notification.forward_email_to_error', {
      type: 'error',
    })
  } catch (error) {
    notify('ra.notification.forward_email_to_error', {
      type: 'error',
    })
  } finally {
    setLoadingForwardEmailModal(false)
    setOpenForwardEmailtModal(false)
    getEmailHistory(record?.item)
    setCardLoading(cardId, false)
  }
}
